import React from "react";
import { SeparatorContainer } from "./style";
const Separator = ({ title }) => {
  return (
    <SeparatorContainer>
      <h4>{title}</h4>
    </SeparatorContainer>
  );
};

export default React.memo(Separator);
